var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLupa = function SvgLupa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.995,
    height: 30.995,
    viewBox: "0 0 8.2008 8.2007",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.0694983 -.10424745)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "green",
      strokeWidth: 0.695755,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      paintOrder: "fill markers stroke"
    },
    cx: 2.8146815,
    cy: 2.918879,
    r: 2.153882
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "green",
      strokeWidth: 0.529169,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      paintOrder: "fill markers stroke"
    },
    width: 0.86872876,
    height: 3.0579257,
    x: -0.7932229,
    y: 7.6171999,
    ry: 0.2258694,
    rx: 0.2258694,
    transform: "rotate(-46.709)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "green",
      strokeWidth: 0.529169,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m4.0100806 4.2549612 1.3273607 1.2544893"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLupa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lupa.aaef41e9.svg";
export { ForwardRef as ReactComponent };